import layoutFactory from './layout';

const Row = layoutFactory({
  element: 'div',
  direction: 'row',
  displayFlex: true,
});

Row.displayName = 'Row';

const Column = layoutFactory({
  element: 'div',
  direction: 'column',
  displayFlex: true,
});

Column.displayName = 'Column';

const Section = layoutFactory({
  element: 'section',
  displayFlex: false,
});

Section.displayName = 'Section';

export { Row, Column, Section };
